export default __webpack_public_path__ + "static/media/NotoSans-Medium.da48589c.ttf";